<template>
  <LcCard class="bg-secondary-secondary" shadow="none">
    <template #header>
      <h2 class="paragraph-bold mb-050">
        {{ headline }}
      </h2>
      <p class="text-secondary-secondary caption-regular">
        {{ subtitle }}
      </p>
    </template>

    <slot />
  </LcCard>
</template>

<script lang="ts" setup>
type Props = {
  headline: string
  subtitle: string
}

defineProps<Props>()
</script>
